import React, {useCallback} from "react";
import {ProductItem} from "filkersjs-model/dist";
import {useCreation} from "ahooks";
import {Card, CardBody, Col} from "reactstrap";
import MediaCard from "src/components/media/MediaCard";
import ItemDataPanel from "src/components/item/ItemDataPanel";

export interface ItemSummaryCardProps {
    item: ProductItem,
    onClick?: () => any
}

const ItemSummaryCard = ({item, onClick}: ItemSummaryCardProps) => {

    const itemMedia = useCreation(() => {
        if (item.media === undefined || item.media.length < 1) {
            return undefined;
        }

        return item.media[0];
    }, [item]);


    const clickHandler = useCallback((event) => {
        event.stopPropagation();
        if (onClick !== undefined) {
            onClick();
        }
    }, [onClick]);

    return (
        <Col xs={6} md={4} className="p-1">
            <Card className="box-shadow flk-clickable-item" onClick={clickHandler}>
                <MediaCard media={itemMedia}/>
                <CardBody className="p-2">
                    <ItemDataPanel item={item}/>
                </CardBody>
            </Card>
        </Col>
    );
}

export default ItemSummaryCard;